<label class="gw-form-label gw-mb-x-small gw-block gw-text-text-primary">{{
  label
}}</label>
<div
  class="gw-rounded-xl gw-border gw-px-medium gw-py-medium gw-transition-colors"
  [class.gw-border-dashed]="!isUploadComplete"
  [class.gw-border-border-normal]="!isUploadComplete && !isDragging"
  [class.gw-bg-background-elevation-1]="!isUploadComplete"
  [class.gw-border-solid]="isUploadComplete || isDragging"
  [class.gw-border-status-positive]="isUploadComplete"
  [class.gw-bg-status-positive-pale]="isUploadComplete"
  [class.gw-border-border-focus]="isDragging && !isUploadComplete"
  [class.gw-bg-background-neutral-1]="isDragging && !isUploadComplete"
  (drop)="onDrop($event)"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave()"
>
  <ng-container *ngIf="isUploadComplete; else uploadPrompt">
    <div class="gw-flex gw-items-center gw-justify-between gw-gap-medium">
      <div class="gw-flex gw-min-w-0 gw-items-center gw-gap-medium">
        <div
          class="gw-flex gw-h-9 gw-w-9 gw-shrink-0 gw-items-center gw-justify-center gw-rounded-full gw-bg-status-positive-pale"
        >
          <gatewee-icon
            icon="@tui.check-circle"
            class="gw-text-status-positive"
            size="1.25rem"
          ></gatewee-icon>
        </div>
        <p
          class="gw-m-0 gw-truncate gw-text-sm gw-font-medium gw-text-status-positive"
        >
          {{ file?.name || ('features.fileUpload.uploaded' | translate) }}
        </p>
      </div>
      <button
        type="button"
        class="gw-flex gw-shrink-0 gw-cursor-pointer gw-items-center gw-justify-center gw-rounded-md gw-border-0 gw-bg-transparent gw-p-x-small gw-text-text-secondary hover:gw-text-text-negative"
        [attr.aria-label]="'common.actions.remove' | translate"
        (click)="clearUpload($event)"
      >
        <gatewee-icon icon="@tui.trash" size="1.25rem"></gatewee-icon>
      </button>
    </div>
  </ng-container>

  <ng-template #uploadPrompt>
    <div class="gw-flex gw-items-center gw-gap-medium">
      <div
        class="gw-flex gw-h-9 gw-w-9 gw-shrink-0 gw-items-center gw-justify-center gw-rounded-full gw-bg-background-accent-1"
      >
        <gatewee-icon
          icon="@phi.upload-simple"
          iconStyle="on-accent"
          size="1.25rem"
        ></gatewee-icon>
      </div>
      <div class="gw-min-w-0 gw-flex-1">
        <label
          class="gw-cursor-pointer gw-text-sm gw-font-semibold gw-text-text-action"
        >
          <input
            type="file"
            class="gw-hidden"
            (change)="onFileSelected($event)"
          />
          {{ 'features.fileUpload.click' | translate }}
        </label>
        <span class="gw-text-sm gw-text-text-secondary">
          {{ 'features.fileUpload.orDrag' | translate }}
        </span>
      </div>
    </div>
    <div class="gw-mt-small gw-text-sm gw-text-text-secondary">
      {{ 'features.fileUpload.maxSize' | translate : {size: maxSizeMb} }}
    </div>
  </ng-template>

  <div *ngIf="error" class="gw-mt-small gw-text-sm gw-text-status-negative">
    {{ error }}
  </div>
</div>
